import React, { useEffect, useState } from "react";
import { getAllTenders } from "../../services/tenderService";
import { format } from "date-fns";

const TENDER_CACHE_KEY = "bscpcr_tenders_cache_v1";

export default function TenderNoticeBoard() {
    const [tenders, setTenders] = useState(() => {
        try {
            const cached = sessionStorage.getItem(TENDER_CACHE_KEY);
            const parsed = cached ? JSON.parse(cached) : [];
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    });
    const [isLoading, setIsLoading] = useState(tenders.length === 0);
    const [selectedTender, setSelectedTender] = useState(null);

    useEffect(() => {
        fetchTenders();
    }, []);

    const fetchTenders = async () => {
        setIsLoading(true);
        try {
            const data = await getAllTenders();
            const active = data.filter((t) => t.isActive);
            const sorted = active.sort(
                (a, b) => new Date(b.publishDate) - new Date(a.publishDate)
            );
            const nextTenders = sorted.slice(0, 4);
            setTenders(nextTenders);
            sessionStorage.setItem(TENDER_CACHE_KEY, JSON.stringify(nextTenders));
        } catch (error) {
            console.error("Error fetching tenders:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const openModal = (tender) => {
        setSelectedTender(tender);
        const modal = new window.bootstrap.Modal(
            document.getElementById("tenderModal")
        );
        modal.show();
    };

    return (
        <>
            {tenders && tenders.length > 0 ? (
                <div className="marquee-outer">
                    <div className="marquee-inner">
                        <div className="marquee-track">
                            {tenders.map((tender) => (
                                <span
                                    key={`a-${tender.id}`}
                                    className="tender-item"
                                    onClick={() => openModal(tender)}
                                >
                                    <span className="new-badge">NEW</span>
                                    <strong>
                                        {format(new Date(tender.publishDate), "dd MMM yyyy")}
                                    </strong>{" "}
                                    -{" "}
                                    {tender.title.length > 50
                                        ? tender.title.substring(0, 50) + "..."
                                        : tender.title}
                                </span>
                            ))}
                        </div>

                        <div className="marquee-track">
                            {tenders.map((tender) => (
                                <span
                                    key={`b-${tender.id}`}
                                    className="tender-item"
                                    onClick={() => openModal(tender)}
                                >
                                    <span className="new-badge">NEW</span>
                                    <strong>
                                        {format(new Date(tender.publishDate), "dd MMM yyyy")}
                                    </strong>{" "}
                                    -{" "}
                                    {tender.title.length > 50
                                        ? tender.title.substring(0, 50) + "..."
                                        : tender.title}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            ) : isLoading ? (
                <p className="text-muted mb-0">Loading latest notices...</p>
            ) : (
                <p className="text-muted mb-0">No active notice found.</p>
            )}

            <div
                className="modal fade"
                id="tenderModal"
                tabIndex="-1"
                aria-labelledby="tenderModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content rounded-4 shadow-lg">
                        <div className="modal-header bg-primary text-white rounded-top-4">
                            <h5 className="modal-title" id="tenderModalLabel">
                                {selectedTender?.title}
                            </h5>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>

                        <div className="modal-body text-start">
                            <p>
                                <strong>Publish Date:</strong>{" "}
                                {selectedTender?.publishDate
                                    ? format(
                                        new Date(selectedTender.publishDate),
                                        "dd MMM yyyy"
                                    )
                                    : "-"}
                            </p>

                            <p>
                                <strong>Closing Date:</strong>{" "}
                                {selectedTender?.closingDate
                                    ? format(
                                        new Date(selectedTender.closingDate),
                                        "dd MMM yyyy"
                                    )
                                    : "-"}
                            </p>

                            <p className="mt-3">
                                <strong>Description:</strong>
                                <br />
                                {selectedTender?.description || "No description available."}
                            </p>

                            {selectedTender?.fileUrl && (
                                <a
                                    href={`http://localhost:5213${selectedTender.fileUrl}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-success mt-3"
                                >
                                    Download Tender File
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
